module.exports = __webpack_public_path__ + "img/46-green.61f02fdf.svg";